import * as yup from 'yup'
import { createDataSchema, createWeakDataRef } from '../schemaUtils'

const documentLink = createDataSchema(
	'DocumentLink',
	yup.object({
		docId: yup.string(),
		name: yup.string(),
		indexable: yup.boolean(),
	})
)

const anchorLink = createDataSchema(
	'AnchorLink',
	yup.object({
		anchorName: yup.string(),
		anchorDataId: createWeakDataRef('Anchor'),
		pageId: createWeakDataRef('Page'),
	})
)

const emailLink = createDataSchema(
	'EmailLink',
	yup.object({
		recipient: yup.string(),
		subject: yup.string(),
		body: yup.string(),
	})
)

export type LinkTarget = '_self' | '_blank'
export type LoginToWixLinkDialog = 'createUser' | 'login' | 'showLogin'

const externalLink = createDataSchema(
	'ExternalLink',
	yup.object({
		url: yup.string(),
		target: yup.mixed<LinkTarget>().oneOf(['_self', '_blank']).default('_blank'),
	})
)

const pageLink = createDataSchema(
	'PageLink',
	yup.object({
		pageId: createWeakDataRef('Page'),
		target: yup.mixed<LinkTarget>().oneOf(['_self', '_blank']).default('_self'),
	})
)

const dynamicPageLink = createDataSchema(
	'DynamicPageLink',
	yup.object({
		routerId: yup.string(),
		innerRoute: yup.string(),
		anchorDataId: yup.string(),
		isTpaRoute: yup.boolean(),
	})
)

const phoneLink = createDataSchema(
	'PhoneLink',
	yup.object({
		phoneNumber: yup.string().max(100),
	})
)

const whatsAppLink = createDataSchema(
	'WhatsAppLink',
	yup.object({
		phoneNumber: yup.string(),
	})
)

const addressLink = createDataSchema(
	'AddressLink',
	yup.object({
		address: yup.string(),
	})
)

const loginToWixLink = createDataSchema(
	'LoginToWixLink',
	yup.object({
		postLoginUrl: yup.string(),
		postSignupUrl: yup.string(),
		dialog: yup.mixed<LoginToWixLinkDialog>().oneOf(['createUser', 'login', 'showLogin']).default('login'),
		sendMail: yup.boolean().default(true),
		mailTemplate: yup.string(),
		userColor: yup.string(),
		loginCompName: yup.string().default(''),
	})
)

const formSubmitButtonLink = createDataSchema('FormSubmitButtonLink', yup.object({}))

export {
	documentLink,
	emailLink,
	externalLink,
	pageLink,
	dynamicPageLink,
	phoneLink,
	whatsAppLink,
	addressLink,
	loginToWixLink,
	formSubmitButtonLink,
	anchorLink,
}
